import { callApiBase } from './base';
import {
  parseFilenameFromDisposition,
  triggerBlobDownload,
  isCsvContentType,
  parseBlobAsJson,
} from '@utils/downloadCsv';

const downloadExport = async ({ endpoint, token, params = {} }) => {
  const response = await callApiBase({
    endpoint,
    token,
    params,
    responseType: 'blob',
  });

  const contentType = response.headers['content-type'] || '';

  if (!isCsvContentType(contentType)) {
    const parsed = await parseBlobAsJson(response.data);
    const message =
      parsed?.errors?.[0]?.message || 'Não foi possível exportar o relatório.';
    const error = new Error(message);
    error.response = { data: parsed || { errors: [{ message }] } };
    throw error;
  }

  const filename = parseFilenameFromDisposition(
    response.headers['content-disposition']
  );

  triggerBlobDownload(response.data, filename);
};

const dashboardApi = {
  // DASHBOARD GRAPHIC - STUDY HOURS
  getGraphicStudyHours: ({ token, params }) =>
    callApiBase({
      title: 'Dashboard - Graphic - Study Hours',
      endpoint: '/v1/graphic/sessions',
      method: 'GET',
      token,
      params,
    }),
  // DASHBOARD GRAPHIC - ACCESS FREQUENCY
  getGraphicAccessFrequency: ({ token, params }) =>
    callApiBase({
      title: 'Dashboard - Graphic - Access Frequency',
      endpoint: '/v1/graphic/accesses',
      method: 'GET',
      token,
      params,
    }),
  // DASHBOARD GRAPHIC - COMPLETED STEPS
  getGraphicCompletedSteps: ({ token, params }) =>
    callApiBase({
      title: 'Dashboard - Graphic - Completed Steps',
      endpoint: '/v1/graphic/steps',
      method: 'GET',
      token,
      params,
    }),
  // DASHBOARD - ACHIEVEMENT
  getDashAchievement: ({ token }) =>
    callApiBase({
      title: 'Dashboard - Achievement',
      endpoint: '/v1/dash/ranking',
      method: 'GET',
      token,
    }),
  // DASHBOARD - STUDY_HOURS
  getDashStudyHours: ({ token, params }) =>
    callApiBase({
      title: 'Dashboard - Study Hours',
      endpoint: '/v1/dash/sessions',
      method: 'GET',
      token,
      params,
    }),
  // DASHBOARD - MOST_ACCESSED_CONTENT
  getDashMostAccessedContent: ({ token }) =>
    callApiBase({
      title: 'Dashboard - Most Accessed Content',
      endpoint: '/v1/dash/most-accessed-content',
      method: 'GET',
      token,
    }),
  // DASHBOARD - WIDGETS
  getDashWidgets: ({ token }) =>
    callApiBase({
      title: 'Dashboard - Widgets',
      endpoint: '/v1/dash/widgets',
      method: 'GET',
      token,
    }),
  exportWidgets: ({ token }) =>
    downloadExport({
      endpoint: '/v1/dash/export/widgets',
      token,
    }),
  exportRanking: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/dash/export/ranking',
      token,
      params,
    }),
  exportSessions: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/dash/export/sessions',
      token,
      params,
    }),
  exportMostAccessedContent: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/dash/export/most-accessed-content',
      token,
      params,
    }),
  exportChartSteps: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/graphic/export/steps',
      token,
      params,
    }),
  exportChartAccesses: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/graphic/export/accesses',
      token,
      params,
    }),
  exportChartSessions: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/graphic/export/sessions',
      token,
      params,
    }),
  exportAll: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/dash/export/all',
      token,
      params,
    }),
  exportConsolidated: ({ token, params }) =>
    downloadExport({
      endpoint: '/v1/dash/export/consolidated',
      token,
      params,
    }),
};

export default dashboardApi;
export { dashboardApi };
